import { User } from "oidc-client";
import { UserInformationState } from "../redux/rootReducerTypes";

export function capitalCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getDisplayName(userIdentity: User, userInfoState: UserInformationState): string {
  let displayName = '';
  const firstName = userIdentity.profile['first-name'];
  const lastName = userIdentity.profile['last-name'];

  if (firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else {
    displayName = userInfoState.userInformation.name ?? "";
  }
  return displayName;
}